import ReactGA4 from "react-ga4";
import { GOOGLE_ANALYTICS_KEY } from "../../consts";

const InitializeGoogleAnalytics = () => {
  // Initialize GA4 - Add your measurement ID
  const analytcsId = GOOGLE_ANALYTICS_KEY;
  if (analytcsId) {
    ReactGA4.initialize(analytcsId);
  };

  // console.log("GA INITIALIZED");
};

const TrackGoogleAnalyticsEvent = (category, action, label) => {
  // console.log("GA event:", category, ":", action, ":", label)

  // Send GA4 Event
  ReactGA4.event({
    category: category,
    action: action,
    label: label
  });
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };
